import { Button } from '@ibsys/kit';
import { PaperclipIcon } from 'lucide-react';
import type { FC } from 'react';
import { type MessageAttachmentResponse, useAttachmentUrl } from '@/entities/conversations';
import { UnavailableAttachment } from './UnavailableAttachment';

type Props = {
  /** Вложение-файл */
  attachment: MessageAttachmentResponse;
  /** Имя вложения */
  name: string;
};

/** Файл во вложениях сообщения — именем; нажатием открывается в новой вкладке. */
export const MessageFileAttachment: FC<Props> = ({ attachment, name }) => {
  const { isLoading, isUnavailable, openInNewTab } = useAttachmentUrl(attachment, false);

  if (isUnavailable) return <UnavailableAttachment name={name} />;

  return (
    <Button
      variant="outline"
      size="sm"
      className="max-w-full self-start not-italic"
      icon={<PaperclipIcon className="size-4" />}
      isLoading={isLoading}
      onClick={openInNewTab}
    >
      <span className="truncate">{name}</span>
    </Button>
  );
};
